export const Template = `<!--
   This is the minimum valid AMP HTML document. Type away
   here and the AMP Validator will re-check your document on the fly.
   -->
<!doctype html>
<html ⚡>
   <head>
      <meta charset="utf-8">
      <link rel="manifest" href="/manifest.json">
      <link rel="shortcut icon" href="/favicon.png">
      <meta name="viewport" content="width=device-width,minimum-scale=1">
      <style amp-boilerplate>body{-webkit-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-moz-animation:-amp-start 8s steps(1,end) 0s 1 normal both;-ms-animation:-amp-start 8s steps(1,end) 0s 1 normal both;animation:-amp-start 8s steps(1,end) 0s 1 normal both}@-webkit-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-moz-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-ms-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@-o-keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}@keyframes -amp-start{from{visibility:hidden}to{visibility:visible}}</style>
      <noscript>
      <style amp-boilerplate>body{-webkit-animation:none;-moz-animation:none;-ms-animation:none;animation:none}</style>
      </noscript>
      <script async src="https://cdn.ampproject.org/v0.js"></script>
      <script async custom-element="amp-form" src="https://cdn.ampproject.org/v0/amp-form-0.1.js"></script>
      <script async custom-element="amp-facebook" src="https://cdn.ampproject.org/v0/amp-facebook-0.1.js"></script>
      <script async custom-element="amp-twitter" src="https://cdn.ampproject.org/v0/amp-twitter-0.1.js"></script>
      <script async custom-element="amp-iframe" src="https://cdn.ampproject.org/v0/amp-iframe-0.1.js"></script>
      <style amp-custom>
         @font-face {
            font-family: 'Calibreweb';
            src: url('https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6da5aba4a9054ed939e9b3_CalibreWeb-Medium.woff') format('woff'), url('https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6da5ac496069d4acec97d8_CalibreWeb-Medium.ttf') format('truetype');
            font-weight: 500;
            font-style: normal;
         }
      
         @font-face {
            font-family: 'Calibreweb';
            src: url('https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6da5ac1431012eca1450cc_CalibreWeb-SemiBold.woff') format('woff'), url('https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6da5aca4a905ea3239e9b4_CalibreWeb-SemiBold.ttf') format('truetype');
            font-weight: 600;
            font-style: normal;
         }

         @font-face {
            font-family: 'Calibreweb';
            src: url('https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6da5ae2dcff341d608418f_CalibreWeb-Regular.woff') format('woff'), url('https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6da5ac143101e6631450cb_CalibreWeb-Regular.ttf') format('truetype');
            font-weight: 400;
            font-style: normal;
         }

         iframe {
                width: 100%;
                margin-top: 65px;
         }
         
         body{
            overflow-x: hidden;
            font-family: Arial,Helvetica Neue,Helvetica,sans-serif;
                color: #333;
                font-size: 14px;
                line-height: 20px;
            background-color: #fff;
            margin: 0px;
         }

         amp-img{max-width: 100%; line-height: 0px;}

         p {
             display: block;
             margin-block-start: 0em;
             margin-block-end: 0em;
             margin-inline-start: 0px;
             margin-inline-end: 0px;
         }

         h4, h5 {
             margin-top: 0;
             margin-bottom: 0;
             font-weight: 700;
         }

         h4 {
             font-size: 18px;
             line-height: 24px;
         }

         h3.featured-heading {
             display: block;
             margin-block-start: 0em;
             margin-block-end: 0em;
             margin-inline-start: 0px;
             margin-inline-end: 0px;
             font-weight: 400;
             color: #000;
             padding: 0 0 12px;
             font-size: 22px;
             line-height: 23px;
             font-family: Calibreweb,sans-serif;
             margin-top: 0;
             margin-bottom: 0;
         }
         a{text-decoration:none;}

         .page-wrapper {
             width: 100%;
             height: auto;
             overflow: hidden;
             position: relative;
         }

         .hero-image{
            background: -webkit-linear-gradient(81deg, rgba(0, 0, 0, 0.38) 11%, transparent 70%) 0% 0% / cover, url(https://uploads-ssl.webflow.com/5c6c62eda4d4b51227422172/5c6d9a4aa4a9056bd939bb84_36c8f047f43078710fbdf1f87dc6558e465f16b3_06_lizza_startup-guide-frankfurt.jpg) center center no-repeat;
            background-size: cover;
            min-height: 600px;
            position: relative;
            overflow: hidden;
            height: 70vh;
            display: flex;
            -ms-flex-pack: center;
            justify-content: center;
            -ms-flex-align: center;
            align-items: center;
            flex-direction: column;
            background-size: 300%;
         }
         .page-title-post {
             font-size: 36px;
             line-height: 38px;
             margin-right: 15px;
             margin-left: 15px;
             max-width: 800px;
             margin-bottom: -5px;
             font-family: Calibreweb, sans-serif;
             color: #fff;
             font-weight: 500;
             text-align: center;
         }

         .article-content-details {
             margin-top: 36px;
             margin-bottom: 45px;
             -ms-flex-direction: column;
             flex-direction: column;
             -ms-flex-pack: distribute;
             justify-content: space-around;
             -ms-flex-wrap: nowrap;
             flex-wrap: nowrap;
             -ms-flex-line-pack: center;
             align-content: center;
             display: -ms-flexbox;
              display: flex;
              margin-right: auto;
              margin-left: auto;
              -ms-flex-pack: center;
              justify-content: center;
              -ms-flex-align: center;
              align-items: center;
              text-align: left;
         }

         .article-reading-time {
             margin-right: 0;
             margin-bottom: 8px;
             float: left;
              clear: none;
              font-family: Calibreweb,sans-serif;
              color: #fff;
              font-size: 16px;
              line-height: 22px;
              font-weight: 400;
         }

         .article_header {
             position: absolute;
             z-index: 2;
             display: -ms-flexbox;
             display: flex;
             width: 100%;
             max-width: 1280px;
             margin-right: auto;
             margin-left: auto;
             padding-right: 0;
             -ms-flex-direction: column;
             flex-direction: column;
             -ms-flex-pack: end;
             justify-content: flex-end;
             -ms-flex-align: center;
             align-items: center;
             -ms-flex: 0 auto;
             flex: 0 1 auto;
             background-color: transparent;
             left: 0;
              top: 0;
              right: 0;
              bottom: 15%;
              padding-bottom: 0;
         }

         .article-author {
             margin-right: 0;
             margin-bottom: 8px;
             display: block;
             margin-left: 0;
             float: none;
             clear: none;
             font-family: Calibreweb,sans-serif;
             color: #fff;
             font-size: 16px;
             line-height: 22px;
             font-weight: 400;
         }
         .article-reading-time {
             margin-right: 0;
             margin-bottom: 8px;
             float: left;
             clear: none;
             font-family: Calibreweb,sans-serif;
             color: #fff;
             font-size: 16px;
             line-height: 22px;
             font-weight: 400;
             margin-top: 0;
         }
         .mobile-nav-container {
             position: fixed;
                 left: 0;
                 top: 0;
                 right: 0;
                 z-index: 1000;
                 display: flex;
                 width: 100%;
                 height: 60px;
                 align-items: center;
                 background: #fff;
         }
         .mobile-nav-container.nav-open {
             background: #fff;
         }

         .navbar-content {
             position: fixed;
             left: 0;
             top: 60px;
             right: 0;
             width: 100%;
             z-index: 1000;
            align-items: center;
            background: #fff;
         }
         .searchbar-content {
             left: 0;
             top: 60px;
             right: 0;
             width: 100%;
             z-index: 1000;
            display: flex;
            align-items: center;
            background: #fff;
         }
          .nav-brand {
              padding-left: 10px;
          }
          .menu-button {
              z-index: 1000;
              display: block;
              width: 50px;
              height: 50px;
              margin-right: 15px;
              margin-left: auto;
              padding: 0;
              display: flex;
              flex-direction: column;
              justify-content: center;
           }
           .menu-line{
            display: block;
             width: 40px;
             height: 1px;
             margin-right: auto;
             margin-left: auto;
             background-color: #333;
             margin-bottom: 4px;
             margin-top: 5px;
           }

           .search-wrapper {
               border-top: 1px solid #e4e4e4;
               position: static;
                display: block;
                margin-right: auto;
                margin-left: auto;
                padding: 30px;
                border-bottom: 1px solid #e4e4e4;
                width: 100%;
               }
           .nav-search-form {
               padding-top: 15px;
               padding-bottom: 15px;
               display: flex;
               margin: -1px 0 0;
               padding-top: 0px;
               padding-bottom: 15px;
               -ms-flex-pack: justify;
               justify-content: space-between;
               -ms-flex-align: baseline;
               align-items: baseline;
           }
           .search-input {
               margin-bottom: 0;
               padding-left: 0;
               border-style: none;
               font-family: Calibreweb,sans-serif;
               color: #9e9d9d;
               font-size: 25px;
               display: block;
               width: 100%;
               padding: 8px 0px;
               line-height: 1.428571429;
               vertical-align: middle;
               height: auto;
               width: 100%;
               min-width: 171px;
           }
           .search-btn-wrapper {
               display: -ms-flexbox;
               display: flex;
               margin-right: 24px;
               padding-top: 1px;
               -ms-flex-direction: row;
               flex-direction: row;
               -ms-flex-align: center;
               align-items: center;
           }
           .search-button {
               display: block;
               border-style: none;
               background-color: hsla(0,0%,100%,0);
               color: #9e9d9d;
               cursor: pointer;
               padding: 9px 15px;
               border: 0;
               line-height: inherit;
               text-decoration: none;
               border-radius: 0;
               font-size: 14px;
           }
           .search-btn-amp-img {
               position: relative;
               -webkit-transform: rotate(-90deg);
               -ms-transform: rotate(-90deg);
               transform: rotate(-90deg);
           }

           .nav-link {
               position: static;
               display: block;
               margin-right: auto;
               margin-left: auto;
               padding: 30px;
               border-bottom: 1px solid #e4e4e4;
               background-color: #fff;
               text-align: center;
               font-family: Calibreweb,sans-serif;
               font-size: 25px;
               text-align: center;
               color: #333;
               text-decoration: none;
           }

           .social-links-wrapper {
               display: -ms-flexbox;
               display: flex;
               margin-right: auto;
               margin-left: auto;
               padding: 0 8px;
               -ms-flex-pack: center;
               justify-content: center;
               -ms-flex-wrap: wrap;
               flex-wrap: wrap;
               background-color: #f7f3f0;
           }
           .social-link {
               padding: 23px;
               padding-bottom: 18px;
           }

           .article {
               margin-top: 38px;
           }

           .article-container{
               padding: 0px 15px;}

           .first-letter {
               position: relative;
               left: 0;
               top: 0;
               display: inline-block;
               margin-top: 5px;
               margin-right: 29px;
               float: left;
           }
           .paragraph-intro {
               font-family: Calibreweb,sans-serif;
               font-size: 25px;
               line-height: 36px;
           }

           .article-content-image-and-caption {
               overflow: hidden;
               width: 100%;
               margin-top: 48px;
               margin-bottom: 48px;
               padding-top: 0;
               padding-bottom: 0;
           }
           .image-caption {
               margin-top: 8px;
               font-family: Calibreweb,sans-serif;
               font-weight: 400;
               text-align: left;
               color: #898e92;
               margin-block-start: 0em;
               margin-block-end: 0em;
           }

           .normal-paragraph {
               display: block;
               margin: 10px auto;
               font-family: Calibreweb,sans-serif;
               color: #000;
               font-size: 18px;
               line-height: 25px;
               text-align: left;
           }

           .quote-wrapper{padding-bottom: 55px;
            padding-top: 10px;
           }

           .top-quotation, .bottom-quotation {
               position: relative;
               clear: left;
           }
           .top-quotation {
               top: 34px;
               float: left;
           }

           .bottom-quotation {
               left: -27px;
               right: 139px;
               bottom: 40px;
               float: right;
           }
           blockquote {
               margin: 0 0 10px;
               padding: 10px 20px;
               border-left: 5px solid #e2e2e2;
               font-size: 18px;
               line-height: 22px;
           }
           .p-blockquote {
               margin-top: 48px;
               margin-bottom: 0;
               padding: 16px 24px;
               clear: left;
               border-left-width: 0;
               font-family: Calibreweb,sans-serif;
               font-size: 28px;
               line-height: 42px;
               font-weight: 600;
           }

           .article-image-large {
               margin-top: 45px;
               margin-bottom: 45px;
           }

           .caption-container, .recomended {
               margin-right: 15px;
               margin-left: 15px;
           }

           .large-amp-img-container {
               position: relative;
               overflow: hidden;
               width: 100%;
               height: 100%;
               margin-bottom: 5px;
           }

           .social-media-embed {
               display: -ms-flexbox;
               display: flex;
               -ms-flex-pack: center;
               justify-content: center;
               -ms-flex-align: start;
               align-items: flex-start;
           }

           .html-embed {
               display: block;
               margin: 50px auto;
           }

           .twoimages {
               margin: 70px -6px;
               margin-top: 45px;
               margin-bottom: 45px;
               line-height: 0px;
           }

           .column-43, .column-44 {
               padding-right: 6px;
               padding-left: 6px;
               line-height: 0px;
           }
           .article-footer {
               padding-top: 70px;
           }

           .sponsor.margin-bottom-24px {
               display: block;
               width: auto;
               padding-right: 0;
               padding-left: 0;
               -ms-flex-direction: row;
               flex-direction: row;
               -ms-flex-pack: start;
               justify-content: flex-start;
               -ms-flex-align: start;
               align-items: flex-start;
               position: relative;
               margin-bottom: 24px;
               padding: 25px 0px;
               border-top: 5px solid #7180cc;
               border-right: 0 none #000;
               border-bottom: 5px solid #7180cc;
               background-color: hsla(0,0%,100%,0);
               margin-right: auto;
               margin-left: auto;
               cursor: pointer;
           }

           .row-6 {
               position: relative;
               display: -ms-flexbox;
               display: flex;
               margin-right: auto;
               margin-left: auto;
               -ms-flex-direction: column;
               flex-direction: column;
               width: auto;
               -ms-flex-pack: justify;
               justify-content: space-between;
               -ms-flex-align: center;
               align-items: center;
               -ms-flex: 0 0 auto;
               flex: 0 0 auto;
           }

           .w-col-tiny-6 {
               width: 50%;
           }

           .sponsor-logo {
               margin-bottom: 29px;
               position: relative;
               display: block;
               margin-right: auto;
               margin-left: auto;
           }

           .column-46 {
               display: -ms-flexbox;
               display: flex;
               padding-right: 0;
               padding-left: 0;
               -ms-flex-direction: column;
               flex-direction: column;
               -ms-flex-pack: center;
               justify-content: center;
               -ms-flex-align: center;
               align-items: center;
           }

           .margin-bottom-8px {
               position: static;
               width: 200px;
               -ms-flex-pack: center;
               justify-content: center;
               text-align: center;
               margin-bottom: 8px;
               font-family: Calibreweb,sans-serif;
               font-size: 14px;
           }

           .author-details {
               position: relative;
               min-height: 400px;
               margin-top: 70px;
               margin-bottom: 16px;
               padding: 25px;
               border: 1px solid #000;
           }

           .row-7 {
               position: relative;
               overflow: visible;
               -ms-flex-direction: column;
               flex-direction: column;
               -ms-flex-pack: start;
               justify-content: flex-start;
               display: flex;
               -ms-flex-align: center;
               align-items: center;
           }

           .column-11 {
               min-height: 200px;
               padding-right: 0;
               padding-left: 0;
           }

           h4.margin-bottom-8px{
            font-size: 18px;
            line-height: 24px;
            font-family: Calibreweb,sans-serif;
            letter-spacing: 0.2px;
           }

           .h-divider {
               padding-right: 0;
               padding-left: 0;
               display: block;
               width: 93vw;
               border-color: hsla(207,4%,55%,.15);
               margin: 67px 30px 32px;
               margin-left: auto;
               margin-right: auto;
               border: 1px solid hsla(207,4%,55%,.18);
               background-color: transparent;
           }

           .more-on-txt, .city-txt {
               display: inline-block;
               margin-bottom: 63px;
               font-family: Calibreweb,sans-serif;
               color: #7180cc;
               font-size: 30px;
           }
           .more-on-txt {
               font-weight: 400;
           }

           .city-txt {
               margin-left: 7px;
               font-weight: 600;
               letter-spacing: 1px;
           }

           .category-related-articles {
               padding-top: 48px;
               padding-bottom: 3px;
               background-color: #fff;
           }

           .row-business {
               position: relative;
               overflow: hidden;
               min-height: 415px;
               margin-right: -10px;
               margin-bottom: 40px;
               margin-left: -10px;
               padding-left: 10px;
               padding-right: 10px;
           }
           .column-35 {
               min-height: 400px;
               width: 100%;
               left: auto;
               right: auto;
           }

           .image-headline.primary {
               display: inline-block;
               padding-top: 0;
               padding-right: 0;
               border-bottom: solid 8px rgb(243, 164, 93);
               margin-bottom: 12px;
           }

           .featured-info {
               -ms-flex-wrap: wrap;
               flex-wrap: wrap;
               position: static;
               left: 0;
               right: 0;
               bottom: 0;
               display: -ms-flexbox;
               display: flex;
               margin-top: 12px;
               -ms-flex-pack: start;
               justify-content: flex-start;
               -ms-flex-align: center;
               align-items: center;
               text-align: left;
               color: #bdbdbd;
               margin-bottom: 15px;

               }
           .featured-clock {
               margin-right: 8px;
               margin-left: 8px;
               padding-left: 0;
           }

           .footer {
               margin-top: 30px;
               margin-right: 0;
               padding-left: 0;
               padding: 48px 15px 0px 15px;
               background-color: #2d3133;
           }

           .footerrow {
               margin-left: 15px;
               position: static;
               display: block;
               width: 100%;
               max-width: 1280px;
               padding-right: 0;
               padding-bottom: 0;
               -ms-flex: 0 auto;
               flex: 0 1 auto;
               background-color: transparent;
               margin-right: auto;
               -ms-flex-pack: center;
               justify-content: center;
               -ms-flex-align: center;
               align-items: center;
               font-family: Calibreweb,sans-serif;
           }

           .row-21 {
               margin-left: 0;
               margin-right: 36px;
           }
           .footer-li {
               display: block;
               margin-bottom: 16px;
               color: #fff;
               text-decoration: none;
           }

           .social-icon{
               margin: 16px 16px 16px 0;
           }
           .footer-header {
               padding-right: 14px;
           }

           .footer-header {
               margin-top: 60px;
               font-size: 20px;
               display: block;
               max-width: 350px;
               margin-bottom: 24px;
               color: #fff;
               line-height: 26px;
               font-weight: 400;
               font-family: Calibreweb,sans-serif;
           }

           .text-field {
               display: block;
               margin-right: auto;
               margin-left: auto;
               padding-right: 0;
               width: 100%;
               height: 52px;
               padding-left: 0;
               float: none;
               clear: none;
               border-style: none none solid;
               border-bottom-width: 1px;
               border-bottom-color: #fff;
               background-color: transparent;
               color: #fffdfd;
               font-style: normal;
               padding: 8px 12px;
               margin-bottom: 10px;
               font-size: 14px;
               line-height: 1.428571429;
               vertical-align: middle;
           }

           .newsletter-btn {
               top: auto;
               right: 0;
               bottom: NaNpx;
               -ms-flex-wrap: nowrap;
               flex-wrap: nowrap;
               position: absolute;
               -ms-flex-direction: row;
               flex-direction: row;
               display: -ms-flexbox;
               display: flex;
               float: none;
               clear: none;
               -ms-flex-pack: center;
               justify-content: center;
               -ms-flex-align: center;
               align-items: center;
           }

           .button.small.secondary.white {
               margin-right: 20px;
               padding-right: 18px;
               background-color: transparent;
               color: #fff;
               display: -ms-flexbox;
               display: flex;
               width: 100%;
               padding-left: 0;
               -ms-flex-pack: start;
               justify-content: flex-start;
               margin-left: 0;
               position: relative;
               padding-top: 15px;
               padding-bottom: 15px;
               float: right;
               -ms-flex-align: center;
               align-items: center;
               font-family: Calibreweb,sans-serif;
               text-align: center;
               border:none;
               font-size: 14px;
           }
           .submit-arrow {
               position: absolute;
               top: 12px;
               right: 16px;
               bottom: 0;
           }

           .list-social-media {
             list-style: none;
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-direction: row;
              padding-left: 0;
           }

      </style>
      [[DYNAMIC_METATAGS]]
   </head>
   <body>
         <div class="page-wrapper">

      <!---- NAVBAR FECHADA ---->
         <div id="closed-nav">
            <div id="mobile-nav" class="mobile-nav-container">
               <a class="brand nav-brand" href="/"><amp-img src="https://startupguide.com/static/media/sg-logo.323e1d72.svg" width="70" height="40.16" alt="" style="margin-top: 10px;"></amp-img></a>
               <div role="button" tabindex="1" on="tap:closed-nav.hide,open-nav.show" class="menu-button nav-button " >
                  <div class="menu-line"></div>
                  <div class="menu-line"></div>
                  <div class="menu-line"></div>
               </div>
            </div>
         </div>
      <!---- NAVBAR FECHADA ----->

      <!---- NAVBAR ABERTA ----->
            <div id="open-nav" class="open-navbar" hidden>
               <nav id="mobile-nav" class="mobile-nav-container nav-open">
                  <a class="brand nav-brand" href="/"><amp-img src="https://startupguide.com/static/media/sg-logo.323e1d72.svg" width="70" height="40.16" alt="" style="margin-top: 5px;"></a>
                  <div role="button" tabindex="2" on="tap:open-nav.hide,closed-nav.show" class="menu-button nav-button" style="position: relative; top: -2px;">
                     <div class="menu-line" style="transition: transform 200ms ease 0s; transform: translateX(0px) translateY(9px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(45deg); transform-style: preserve-3d;"></div>
                     <div class="menu-line" style="transition: width 0ms ease 0s; width: 0px;"></div>
                     <div class="menu-line" style="transition: transform 200ms ease 0s; transform: translateX(0px) translateY(-11px) translateZ(0px) rotateX(0deg) rotateY(0deg) rotateZ(-45deg); transform-style: preserve-3d;"></div>
                  </div>
               </nav>
               <div class="navbar-content">
                  <!--
                  <div class="searchbar-content">
                     <div class="search-wrapper" style="background-color: rgb(255, 255, 255); padding: 1px 5%;">
                        <form action="/search" class="search-2 nav-search-form">
                           <input type="search" class="search-input w-input nav-search-input" maxlength="256" name="query" placeholder="Type to search" id="menu-search" required="">
                           <div class="search-btn-wrapper"><input type="submit" class="search-button w-button" value="RESULTS"><amp-img alt="" src="https://startupguide.com/static/media/arrow-down.1517ddc3.svg"  height="18" class="search-btn-amp-img"></div>
                        </form>
                     </div>
                  </div> -->
                  <a class="nav-link" href="/cities">All Locations</a>
                  <a class="nav-link" href="/about">About</a>
                  <a class="nav-link" href="/shop">SHOP</a>

                  <div class="social-links-wrapper">
                     <a href="https://www.facebook.com/StartupGuideHQ/" target="_blank" rel="noopener noreferrer" class="social-link">
                        <amp-img src="https://startupguide.com/static/media/icon-share-facebook.3ff25df7.svg"  height="30" alt="">
                     </a>
                     <a href="https://twitter.com/startupguidehq" target="_blank" rel="noopener noreferrer" class="social-link">
                        <amp-img src="https://startupguide.com/static/media/icon-share-twitter.9f5084f7.svg"  height="30" alt="">
                     </a>
                     <a href="https://www.instagram.com/startupguidehq/" rel="noopener noreferrer" target="_blank" class="social-link">
                        <amp-img src="https://startupguide.com/static/media/instagram.0c3563f1.svg"  height="30" alt="">
                     </a>
                     <a href="https://www.linkedin.com/company/startupguidehq" rel="noopener noreferrer" target="_blank" class="social-link">
                        <amp-img src="https://startupguide.com/static/media/linkdin.ec8efa7d.svg"  height="30" alt="">
                     </a>
                  </div>

               </div>
            </div>
      <!---- NAVBAR ABERTA ----->
      [[DYNAMIC-HEADER]]
      <!-- hero amp-img -->
      <div class="article">

         <div class="article-container w-clearfix">
           [[DYNAMIC-ARTICLE-CONTENT]]


           [[DYNAMIC-ARTICLE-AUTHOR]]

      </div> <!-- article -->
      <div class="h-divider"></div>
      [[DYNAMIC-RECOMENDATIONS]]

      <div class="footer">
         <div class="footerrow">
            <div class="row-21 w-row">
               <div class="column-9 w-col w-col-4 w-col-medium-4 w-col-small-small-stack w-col-tiny-tiny-stack">
                  <a target="_self" href="https://www.startupguide.com/shop" class="footer-li">Online Shop</a>
                  <a target="_self" href="https://startupguide.com/stores" class="footer-li">Startup Guide Stores</a>
                  <a target="_self" href="https://membership.startupguide.com/" class="footer-li">Membership</a>
                  <a target="_self" href="https://startupguide.com/about#team" class="footer-li">Team</a>
               </div>
               <div class="column-56 w-col w-col-4 w-col-medium-4 w-col-small-small-stack w-col-tiny-tiny-stack">
                  <a target="_self" href="https://startupguide.com/about" class="footer-li">About Us</a>
                  <a target="_self" href="https://startupguide.com/about#contact" class="footer-li">Contact</a>
                  <a target="_blank" href="https://www.iubenda.com/privacy-policy/68510883" class="footer-li">Privacy Policy</a>
                  <div class="social-iconsm">
                     <a target="_blank" href="https://www.facebook.com/startupguidehq/">
                        <amp-img alt="" src="https://startupguide.netlify.com/static/media/icon-share-facebook.3ff25df7.svg"  height="24" width="24" class="social-icon"></amp-img>
                     </a>
                     <a target="_blank" href="https://twitter.com/StartupGuideHQ/">
                        <amp-img alt="" src="https://startupguide.netlify.com/static/media/icon-share-twitter.9f5084f7.svg"  height="24" width="24" class="social-icon"></amp-img>
                     </a>
                     <a target="_blank" href="https://www.instagram.com/startupguidehq/">
                        <amp-img alt="" src="https://startupguide.netlify.com/static/media/instagram.0c3563f1.svg"  height="24" width="24" class="social-icon"></amp-img>
                     </a>
                     <a target="_blank" href="https://www.linkedin.com/company/startupguidehq/">
                        <amp-img alt="" src="https://startupguide.netlify.com/static/media/linkdin.ec8efa7d.svg"  height="24" width="24" class="social-icon"></amp-img>
                     </a>
                     <a target="_blank" href="https://www.youtube.com/channel/UCvhUxkZtfB8z0gpx4hq-aaA?">
                        <amp-img alt="" src="https://startupguide.netlify.com/static/media/logo-youtube.b8dd122d.svg"  height="24" width="24" class="social-icon"></amp-img>
                     </a>
                  </div>
               </div>
               <div class="column-57 w-col w-col-4 w-col-medium-4 w-col-small-small-stack w-col-tiny-tiny-stack">
                  <h1>
                     <strong class="footer-header">Subscribe to our newsletter to receive news,
                        <br>alerts and updates
                     </strong>
                  </h1>
                  <div class="form-block">
                     <!-- <form id="email-form" name="email-form" data-name="Email Form" class="form"> -->
                        <div class="div-block-9">
                           <input type="email" class="text-field w-input" maxlength="256" name="email-2" data-name="Email 2" placeholder="Your email *" id="email-2" required="">
                           <div class="newsletter-btn w-clearfix">
                              <input type="submit" data-wait="Please wait..." class="button small secondary white w-button" value="Sign me up">
                              <amp-img alt="" src="https://startupguide.netlify.com/static/media/ARROW-FW.6f16f63f.svg"  width="10" height="18.69" class="submit-arrow"></amp-img>
                           </div>
                        </div>
                     <!-- </form> -->
                  </div>
               </div>
            </div>
         </div>
      </div>

   </div><!-- page wrapper -->


   </body>
</html>
`;
